(() => {
  const placeBackgrounds = () => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    const backgrounds = [
      ['kf-secret-updated-video', '.kf-secret-video-background'],
      ['kf-gatherings-updated-video', '.kf-gatherings-video-background'],
      ['kf-king-farms-drone-video', '.kf-king-farms-video-background']
    ];
    backgrounds.forEach(([id, selector]) => {
      const video = document.getElementById(id);
      if (!video || video.parentElement === document.body) return;
      const background = document.querySelector(selector);
      if (background && background.parentElement === document.body) {
        background.insertAdjacentElement('afterend', video);
      } else {
        document.body.insertBefore(video, document.body.firstChild);
      }
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeBackgrounds, { once: true });
  } else {
    placeBackgrounds();
  }
  window.addEventListener('pageshow', placeBackgrounds);
  document.addEventListener('shopify:section:load', placeBackgrounds);
})();